import { Icon } from "@chakra-ui/react";
const CallOutgoingCall = () => {
  return (
    <>
      <Icon
        width="4"
        height="4"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 9.74115L10.2867 8.62115C10.4366 8.4712 10.6272 8.36854 10.8349 8.32587C11.0426 8.28321 11.2582 8.30243 11.4551 8.38116L12.8191 8.9268C13.0202 9.00725 13.1925 9.1461 13.3139 9.32545C13.4353 9.50479 13.5001 9.7164 13.5 9.93295V12.4136C13.5004 12.561 13.4706 12.707 13.4126 12.8425C13.3545 12.978 13.2695 13.1003 13.1625 13.2018C13.0556 13.3033 12.9291 13.3819 12.7907 13.4329C12.6524 13.4838 12.5051 13.5059 12.3579 13.4979C2.79692 12.9027 0.866071 4.8057 0.507321 1.70396C0.489962 1.55233 0.504905 1.39875 0.551167 1.25332C0.597428 1.10788 0.67396 0.973895 0.775727 0.860164C0.877493 0.746434 1.00219 0.655541 1.14161 0.593465C1.28102 0.531389 1.43201 0.499537 1.58462 0.500005H4.02102C4.23754 0.500001 4.44908 0.564877 4.62837 0.686262C4.80766 0.807648 4.94646 0.979973 5.02687 1.18101L5.57252 2.54501C5.65124 2.74187 5.67046 2.9575 5.62779 3.16518C5.58513 3.37287 5.48247 3.56346 5.33252 3.71335L4.21252 4.83336C4.21252 4.83336 4.83337 9.1995 9.16667 9.74115Z"
          fill="#39C449"
        />
        <path
          d="M9 1V2H11.293L8 5.293L8.707 6L12 2.707V5H13V1H9Z"
          fill="#39C449"
        />
      </Icon>
    </>
  );
};
export default CallOutgoingCall;
